import { useState, useEffect } from 'react'
import dynamic from 'next/dynamic'
import { useBreakpoint } from '~/hooks'
const SwapPriceChart = dynamic(
  () => import('~/components/charts/SwapPriceChart'),
  {
    ssr: false,
  },
)
const MiniSwapPriceChart = dynamic(
  () => import('~/components/charts/MiniSwapPriceChart'),
  {
    ssr: false,
  },
)

const Chart = () => {
  const { isMobile } = useBreakpoint()
  const [miniChartVisible, setMiniChartVisible] = useState(isMobile)

  useEffect(() => {
    setMiniChartVisible(isMobile)
  }, [isMobile])

  const handleChartExpand = () => {
    setMiniChartVisible(!miniChartVisible)
  }

  return miniChartVisible ? (
    <MiniSwapPriceChart handleChartExpand={handleChartExpand} />
  ) : (
    <SwapPriceChart handleChartExpand={handleChartExpand} />
  )
}

export default Chart
